// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"2a9ce207","252":"32a4a6fa","260":"ea6cb52c","419":"462f2d1e","485":"ddcf1844","563":"ef98c979","721":"e170036b","787":"6ffca7c4","883":"e0ebcb95","906":"b048ddb0","942":"095f0fcd"}[chunkId] + ".chunk.js";
};